import React from "react";
import { Phone, MessageSquare } from "lucide-react";
import { BUSINESS } from "@/data/site";

export const MobileContactBar = () => (
  <div
    data-testid="mobile-contact-bar"
    className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-[#FDFBF7]/95 backdrop-blur-xl border-t border-border px-4 pt-2.5 pb-[calc(0.625rem+env(safe-area-inset-bottom))] flex gap-3 shadow-[0_-4px_20px_rgba(136,156,133,0.12)]"
  >
    <a
      href={`tel:${BUSINESS.phoneRaw}`}
      data-testid="mobile-bar-call"
      className="flex-1 flex items-center justify-center gap-2 h-12 rounded-full bg-primary text-primary-foreground font-medium text-[15px] transition-transform duration-200 active:scale-95"
    >
      <Phone className="w-5 h-5" /> Call
    </a>
    <a
      href={`sms:${BUSINESS.phoneRaw}`}
      data-testid="mobile-bar-text"
      className="flex-1 flex items-center justify-center gap-2 h-12 rounded-full border border-primary text-primary font-medium text-[15px] bg-card transition-transform duration-200 active:scale-95"
    >
      <MessageSquare className="w-5 h-5" /> Text
    </a>
  </div>
);
